import { Student, studentsProvider } from "../providers/studentsProvider";
import { uncapitalize } from "./string";

/**
 * Resolves to `true` if the error was handled, to `false` otherwise.
 */
export async function handleBookingError(
  error: any,
  studentOrStudentId: Student | string | null | undefined,
): Promise<boolean> {
  const code = error.details?.code;

  async function student() {
    if (typeof studentOrStudentId === "string") {
      try {
        const { data: student } = await studentsProvider.getOne("students", { id: studentOrStudentId });
        return student;
      } catch {
        return undefined;
      }
    } else {
      return studentOrStudentId;
    }
  }

  async function studentName() {
    return (await student())?.callName ?? "Der Fahrschüler";
  }

  if (code === "appointment.capacity_reached") {
    showErrorToast("Alle Plätze sind bereits belegt.");
  } else if (code === "payments.outstanding") {
    showErrorToast(`${await studentName()} hat offene Zahlungen.`);
  } else if (code === "student.base-fee-not-paid") {
    showErrorToast(`${await studentName()} hat den Grundbetrag noch nicht bezahlt.`);
  } else if (code === "student.cannot_book_theory_lessons") {
    showErrorToast(`${await studentName()} hat kein Paket gebucht, das Theorieunterricht enthält.`);
  } else if (code === "student.not-active") {
    const { status, verboseStatus } = (await student()) ?? {};
    if (status === "active" || !verboseStatus) {
      showErrorToast(`${await studentName()} ist nicht aktiv.`);
    } else {
      showErrorToast(`${await studentName()} ist nicht aktiv, sondern: ${uncapitalize(verboseStatus)}.`);
    }
  } else if (code === "student.not-enough-credit") {
    showErrorToast(`${await studentName()} hat nicht genügend Guthaben.`);
  } else if (code === "student.no-payment-method") {
    showErrorToast(`${await studentName()} hat keine gültige Zahlungsmethode hinterlegt.`);
  } else {
    return false;
  }
  return true;
}
